import { render, staticRenderFns } from "./PaperResult.vue?vue&type=template&id=6a421ffc"
import script from "./PaperResult.vue?vue&type=script&lang=js"
export * from "./PaperResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports